(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.js-copy-link');
    if (!link) return;
    e.preventDefault();
    var url = link.getAttribute('data-url') || window.location.href;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
  document.querySelectorAll('.faq-main .acc-head').forEach(function (b) {
    b.addEventListener('click', function () {
      b.parentElement.classList.toggle('is-open');
    });
  });

  (function () {
    var HEADER_OFFSET = 94;
    var tocItems = Array.prototype.slice.call(document.querySelectorAll('.faq-toc-item'));
    var sections = tocItems
      .map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); })
      .filter(Boolean);

    tocItems.forEach(function (item, i) {
      item.addEventListener('click', function (e) {
        var target = sections[i];
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    function updateActive() {
      var probe = window.scrollY + HEADER_OFFSET + 1;
      var activeIdx = 0;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].offsetTop <= probe) activeIdx = i;
      }
      tocItems.forEach(function (it, i) { it.classList.toggle('on', i === activeIdx); });
    }
    if (sections.length) {
      updateActive();
      window.addEventListener('scroll', updateActive, { passive: true });
      window.addEventListener('resize', updateActive);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
